module.exports = __webpack_public_path__ + "img/summary-slide.216cd161.svg";